<template>
  <div class="header__lang">
    <AppDropdown size="sm" position="center" variation="link">
      <template #trigger>
        {{ props.currentLang }}
      </template>

      <slot></slot>
    </AppDropdown>
  </div>
</template>

<script setup lang="ts">
import AppDropdown from "@/components/app-dropdown.vue";

const props = defineProps<{
  currentLang: string;
}>();
</script>
